import React from 'react'
import { Modal } from "react-bootstrap";
import CrossIcon from "../../assets/img/file-cut-icon.png";
const BaseModal = ({ show, onHide, title, children, footerButtons }) => {
  return (
    <Modal show={show} onHide={onHide} scrollable>
    <Modal.Header>
      <Modal.Title>{title}</Modal.Title>
      <button onClick={onHide} className="modal-close" aria-label="Close">
        <img src={CrossIcon} alt="Close" style={{ width: "20px", height: "20px" }} />
      </button>
    </Modal.Header>
    <Modal.Body>{children}</Modal.Body>
    <Modal.Footer>
      {footerButtons}
    </Modal.Footer>
  </Modal>
  )
}

export default BaseModal